import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-permissions-list',
  templateUrl: './permissions-list.component.html',
  styleUrls: ['./permissions-list.component.scss']
})
export class PermissionsListComponent implements OnInit {

  public list = [];
  message = null;
  class = null;

  constructor(private router: Router, private api: ApiService, private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) {
  }

  public settings = {
    actions: {
      position: 'right',
      add: false,
      edit: false,
      delete: false
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      role: {
        title: 'Role'
      },
      _id: {
        title:'Edit',
        type:'html',
        valuePrepareFunction:(cell,row)=>{
          return `<a href="permissions/edit/${row._id}"  class="ng2-smart-action ng2-smart-action-edit-edit ng-star-inserted"><i class="fa fa-pencil"></i></a>&nbsp; `
        },
        filter:false
      },
    },
  };

  ngOnInit() {
    this.http.get<any>(`${environment.apiUrl}/permission/`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          this.list = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

}
